

export class MapUpdateInput implements IMapUpdateInput {
    /** The auto-generated id of the map master */
    mapId!: number;
    /** The map name with 255 character limit */
    mapName!: string;

    constructor(data?: IMapUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapId = _data["mapId"];
            this.mapName = _data["mapName"];
        }
    }

    static fromJS(data: any): MapUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new MapUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapId"] = this.mapId;
        data["mapName"] = this.mapName;
        return data; 
    }
}

export interface IMapUpdateInput {
    /** The auto-generated id of the map master */
    mapId: number;
    /** The map name with 255 character limit */
    mapName: string;
}

